import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { IDataConnection } from '../../../ts/ServerApi/types/IDataConnection';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { ISiteNameWithId } from '../../../ts/ServerApi/types/ISiteNameWithId';
import { INamedItem } from '../../../ts/ServerApi/types/resourceParts';
import { FlowOutputStep } from '../types/FlowOutputStep';
import { FlowOutputStepRun } from '../types/FlowOutputStepRun';
import { FlowRun } from '../types/FlowRun';
import { RunFlowTask } from '../types/RunFlowTask';

export type GetRunFlowTasksParams = IGetItemsParams;

export type GetRunFlowTasksResult = IGetItemsResult & {
  readonly tasks: ReadonlyArray<RunFlowTask>;
  readonly flows: ReadonlyArray<INamedItem>;
  readonly schedules: ReadonlyArray<ISchedule>;
  readonly sites: ReadonlyArray<ISiteNameWithId>;
  readonly flowOutputSteps: ReadonlyArray<FlowOutputStep>;
  readonly flowRuns: ReadonlyArray<FlowRun>;
  readonly flowOutputStepRuns: ReadonlyArray<FlowOutputStepRun>;
  readonly dataConnections: ReadonlyArray<IDataConnection>;
};

export class GetRunFlowTasksRequest extends Request<GetRunFlowTasksParams, GetRunFlowTasksResult> {
  constructor(params: GetRunFlowTasksParams) {
    super('getRunFlowTasks', params);
  }
}

export class GetRunFlowTasksForServerRequest extends Request<GetRunFlowTasksParams, GetRunFlowTasksResult> {
  constructor(params: GetRunFlowTasksParams) {
    super('getRunFlowTasksForServer', params);
  }
}
